import { ApplicationConfig, ErrorHandler, provideZonelessChangeDetection } from "@angular/core"
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http"
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async"
import { provideRouter, withComponentInputBinding, withNavigationErrorHandler } from "@angular/router"
import { AuthInterceptor } from "app/factories/auth_inteceptor"
import { tvAppRoutes } from "app/app-routing.module"
import { lazyLoadRetryHandler } from "common/lazy_load_error"
import { BugsnagErrorHandler } from "@bugsnag/plugin-angular"
import { REALTIME_CONFIG } from "common/realtime/centrifugo.service"

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: REALTIME_CONFIG, useValue: { connectUrl: '/api/realtime/connect', subscribeUrl: '/api/realtime/subscribe' } },
    { provide: ErrorHandler, useFactory: () => { return new BugsnagErrorHandler(); } },
    provideAnimationsAsync(),
    provideRouter(tvAppRoutes, withComponentInputBinding(), withNavigationErrorHandler(lazyLoadRetryHandler)),
    provideHttpClient(withInterceptorsFromDi())
    // Not currently using serviceworker as it 401's requests on ChromeCasts
  ]
}
